import { defineComponent, ref, Ref, watch } from 'vue';
import { HoursOfOperationType, HoursOfOperationHolidaysCondition } from '@truckdown/locations';

type HoursSettings = {
    type: HoursOfOperationType,
    majorHolidaysCondition: HoursOfOperationHolidaysCondition,
}

interface IData {
    model: Ref<HoursSettings>,
    hoursTypeOriginal: Ref<HoursOfOperationType>
}

const getInitialData = function (props: any): IData {
    return {
        model: ref<HoursSettings>({
            type: props.hoursType,
            majorHolidaysCondition: props.holidayCondition,
        }),
        hoursTypeOriginal: ref<HoursOfOperationType>(props.hoursType)
    };
}


const getMethods = function (data: IData, ctx: any) {
    return {
        updateHoursModel: function () {
            ctx.emit("update-model", data.model.value, true);
        }
    };
}

export default defineComponent({
    name: "HoursSettings",
    props: {
        hoursType: {
            type: Number as () => HoursOfOperationType,
            default: HoursOfOperationType.SelectHours
        },
        holidayCondition: {
            type: Number as () => HoursOfOperationHolidaysCondition,
            default: HoursOfOperationHolidaysCondition.RegularHours
        }
    },
    emits: ['update-model'],
   
    setup: function (props, ctx) {
        var data = getInitialData(props);
        var methods = getMethods(data, ctx);

        watch(() => props.hoursType, (val) => {
            if (val != undefined) data.model.value.type = val;
        });

        watch(() => props.holidayCondition, (val) => {
            if (val != undefined) data.model.value.majorHolidaysCondition = val;
        });


        return {
            ...data,
            ...methods,
            'HoursOfOperationType': HoursOfOperationType,
            'HoursOfOperationHolidaysCondition': HoursOfOperationHolidaysCondition
        }
    }
});